import { render, staticRenderFns } from "./accountSynchronization.vue?vue&type=template&id=35b967dc&scoped=true&"
import script from "./accountSynchronization.vue?vue&type=script&lang=js&"
export * from "./accountSynchronization.vue?vue&type=script&lang=js&"
import style0 from "./accountSynchronization.vue?vue&type=style&index=0&id=35b967dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b967dc",
  null
  
)

export default component.exports